var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"fixed-bottom"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row bg-primary"},[_c('div',{staticClass:"col text-white m-1"},[_vm._v(" Built with "),_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fas fa-heart"})]),_vm._v(" by eHealth4everyone ")])])])])])
}]

export { render, staticRenderFns }